import { Spacing } from '@lichtblick/theme';
import styled from 'styled-components';
import { getSharedInputRowStyles, sharedInputStyles, sharedWrapperStyles } from '../Textfield/Textfield.styles';
export const Wrapper = styled.div`
  ${sharedWrapperStyles}
`;
export const InputRow = styled.div`
  ${getSharedInputRowStyles}
  height: auto;
`;
export const Input = styled.textarea`
  ${sharedInputStyles.base}
  padding-bottom: ${Spacing.Xs};
  padding-top: ${Spacing.Xs};
`;

//# sourceMappingURL=Textarea.styles.js.map